import { createLaminateProductHook } from '../laminate-api/createLaminateProductHook';
import { useFetchEndCapQuery } from './endCapsService';

import { EndCapProduct } from '~/core/models';

const _useEndCaps =
  createLaminateProductHook<EndCapProduct>(useFetchEndCapQuery);

export const useEndCaps = () => {
  const { data, isFetching, ...rest } = _useEndCaps();

  return {
    endCaps: data,
    isFetchingEndCaps: isFetching,
    ...rest,
  };
};

export type UseEndCapsReturn = ReturnType<typeof useEndCaps>;
